import './OperationsGuide.css';

import { GUIDE_TARGET_TITLES, GuideTarget } from './operationsGuideSections';

import { Link } from 'react-router-dom';
import React from 'react';

interface GuideLinkProps {
  /** Section or heading to land on. Titles come from the guide so the two cannot drift. */
  section: GuideTarget;
  /** Overrides the default "Guide" wording when a page needs to be more specific. */
  label?: string;
  /** Adds left margin for use immediately after a heading or label. */
  spaced?: boolean;
}

/**
 * The in-app pointer to the operations guide.
 *
 * Deliberately small and repeated rather than a single help menu item: the
 * question an analyst has is always about the control in front of them, so the
 * answer has to be reachable from that control, already scrolled to the right
 * section.
 */
const GuideLink: React.FC<GuideLinkProps> = ({ section, label = 'Guide', spaced }) => (
  <Link
    to={`/guide#${section}`}
    className={`guide-hint${spaced ? ' guide-hint-block' : ''}`}
    title={`Operations guide: ${GUIDE_TARGET_TITLES[section]}`}
  >
    <span className="guide-hint-icon" aria-hidden="true">?</span>
    {label}
  </Link>
);

export default GuideLink;
